import { Form, Formik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import FormFooter from '../../../../components/form-footer';
import IntakeInsuranceInvestigationBusinessAdditionalInformationFields from '../../../../components/intake/insurance-investigation/business/additional-information-fields';
import InsuranceInvestigationBusinessAdditionalInformationSchema from '../../../../validation-schemas/insurance-investigation-business-additional-information-schema';
import { selectActiveFormInsuranceInvestigationBusinessAdditionalInformation, updateActiveFormInsuranceInvestigationBusinessAdditionalInformation, selectActiveFormInsuranceInvestigationBusinessDetails } from '../../../../reducers/active-form-slice';
import FormHeaderButtons from '../../form-header-buttons';
import { hasNonBlankValues } from '../../../../utility/has-values';


const IntakeInsuranceInvestigationBusinessAdditionalInformation = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();


    /**
     * get current form values
     */
    const insuranceInvestigationBusinessDetails = useSelector(selectActiveFormInsuranceInvestigationBusinessDetails);
    const insuranceInvestigationBusinessAdditionalInformation = useSelector(selectActiveFormInsuranceInvestigationBusinessAdditionalInformation);
    const hasValues = hasNonBlankValues(insuranceInvestigationBusinessAdditionalInformation);


    /**
     * handle the previous button
     */
    const handlePrevious = () => {
        navigate("/intake/insurance-investigation-business/drivers-details");
    };


    /**
     * update active form & continue
     */
    const handleSubmit = (values) => {
        dispatch(updateActiveFormInsuranceInvestigationBusinessAdditionalInformation(values));
        navigate("/intake/additional-information");
    };

    /**
     * handle save for later
     */
    const handleSaveForLater = (values) => {
        dispatch(updateActiveFormInsuranceInvestigationBusinessAdditionalInformation(values));
    };


    /**
     * setup the initial values
     */
    const initialValues = {
        letterOfAcknowledgement: '',
        defendantProofOfInsuranceCard: '',
        defendantDriversLicense: '',
        trafficCollisionReport: ''
    };


    return (
        <div className="page intake">
            <Formik
                initialValues={hasValues ? insuranceInvestigationBusinessAdditionalInformation : initialValues}
                validationSchema={InsuranceInvestigationBusinessAdditionalInformationSchema.fields.insuranceInvestigationBusinessAdditionalInformation}
                onSubmit={handleSubmit}
            >
                {({ errors, dirty, touched, isValid, values }) => (
                    <Form>
                        <div className="form-header-buttons">
                            <div>
                                <h2>Additional Information</h2>
                                <p>FILL WITH “N/A” IF NOT APPLICABLE ON REQUIRED FIELDS</p>
                            </div>
                            <FormHeaderButtons updateForm={() => handleSaveForLater(values)}/>
                        </div>
                        
                        <IntakeInsuranceInvestigationBusinessAdditionalInformationFields
                            errors={errors}
                            touched={touched}
                        />

                        <FormFooter
                            handlePrevious={handlePrevious}
                            showPrevious={true}
                            disableNext={!((dirty || hasValues) && isValid)}
                            showNext={true}
                            progress={`75`}
                        />
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default IntakeInsuranceInvestigationBusinessAdditionalInformation;